import { render } from "./ACE.vue?vue&type=template&id=c09b3896"
import script from "./ACE.vue?vue&type=script&lang=js"
export * from "./ACE.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__